import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'EmergencyService',
    controller: 'Addressbook'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'DelItemList',
    'GetItemById',
    'FindByConditions',
    'GetPageContentByConditions',
    'UpdateItemList'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const AddressbookApi = ZJApi.defineNewApi('AddressbookApi', factory);

export default AddressbookApi;